<template>

  <q-separator class="q-mb-md" />

</template>

<script>


export default {
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {

    };
  },

  methods: {

  },
  computed: {

  },
  mounted() {

  }
}
</script>
